<div *ngIf="config" class="authorisation-popover">
  <div
    *ngIf="showCurrentTask"
    class="authorisation-popover-header pt-10 authorisation-popover-section">
    <span class="content-title">
      {{ 'TOOLBAR.AUTHORISATION_CURRENT_TASK' | translate }}
    </span>
    <a [href]="TASK_LIST_URL" class="authorisation-title" [target]="anchorTarget">
      {{ config.title }}
    </a>
  </div>

  <mat-divider *ngIf="showCurrentTask"></mat-divider>
  <div class="authorisation-popover-section authorisation-popover-user">
    <div class="content-title">
      {{ 'TOOLBAR.TRAINING_RAISED_BY_LABEL' | translate }}
    </div>
    <q9-user-info [user]="config.createdBy"></q9-user-info>
  </div>
  <mat-divider></mat-divider>

  <ng-container *ngIf="userHistory.length; else spinner">
    <div *ngFor="let historyItem of userHistory; last as isLast">
      <div class="authorisation-popover-section authorisation-popover-user">
        <div class="content-title">
          {{ historyItem.authorisationTask.status | authorisationTaskStatus | translate }}
        </div>
        <q9-user-info [user]="historyItem.user"></q9-user-info>
      </div>
      <mat-divider *ngIf="!isLast || config.description"></mat-divider>
    </div>
  </ng-container>
  <ng-template #spinner>
    <div class="spinner-container">
      <mat-spinner strokeWidth="1" diameter="20"></mat-spinner>
    </div>
    <mat-divider></mat-divider>
  </ng-template>

  <div
    *ngIf="config.description"
    class="authorisation-popover-section authorisation-popover--description">
    <span class="q9-label">
      {{ 'TOOLBAR.TRAINING_INFO_COMMENT_LABEL' | translate }}
    </span>
    <span class="q9-section-data">
      {{ config?.description | interpolate }}
    </span>
  </div>
</div>
